export default __webpack_public_path__ + "static/media/985.a169ebea.png";